import React from 'react'
import Footer from '../Component/NavBarFooter/Footer'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/GelleryDetail/Banner'

function GelleryDetail() {
  return (
    <div>
        <NavBar/>
        <Banner/>
        <Footer/>
    </div>
  )
}

export default GelleryDetail